export default "__VITE_ASSET__BeTonXUg__"